var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-card", class: { "-arrow": _vm.arrow } },
    [
      _vm.icon || _vm.title || _vm.$slots.action
        ? _c(
            "header",
            { staticClass: "header", class: { "-actions": _vm.$slots.action } },
            [
              _vm.icon
                ? _c(
                    "c-title",
                    {
                      staticClass: "title",
                      attrs: {
                        size: _vm.size,
                        icon: _vm.icon,
                        "icon-size": "17"
                      }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
                  )
                : _c(
                    "c-title",
                    { staticClass: "title", attrs: { size: _vm.size } },
                    [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [_vm._t("action")], 2)
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b6f12f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b6f12f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CCard.vue
// module id = wQ46
// module chunks = 1624